import { SmsConstants,editSmsProviderConstants } from '../Constants';
import { adminUsersServices } from '../Services';

export const SMSUserActions = {
    searchSms,
    editSms
};

function searchSms(data:any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: SmsConstants.SEARCH_SMS_REQUEST,
            data: null
        }));
        adminUsersServices.searchSms(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: SmsConstants.SEARCH_SMS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: SmsConstants.SEARCH_SMS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: SmsConstants.SEARCH_SMS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function editSms(data:any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: editSmsProviderConstants.EDIT_SMSPROVIDER_REQUEST,
            data: null
        }));
        adminUsersServices.editSmsProvider(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: editSmsProviderConstants.EDIT_SMSPROVIDER_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: editSmsProviderConstants.EDIT_SMSPROVIDER_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: editSmsProviderConstants.EDIT_SMSPROVIDER_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}


function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}